<template>
    <div class="link-single-page">
        <link-navigator-main ref="navigator"
                             v-if="isInitialized"
                             page404="/modules/common/not-found-page.vue"
                             :idGenerator="idGenerator"
                             :storageKey="`single${navigationStorageKey}`"
                             hide-header
                             :showPathInUrl="false"
                             disabledStorage/>
    </div>
</template>

<script>
    export default {
        name: "link-single-page",
        props: {},
        data() {
            return {
                page: null,                                     //当前打开的页面的信息
                isInitialized: false,                           //当前是否已经初始化完数据
                navigationStorageKey: ''                        //当前导航缓存key
            }
        },
        async created() {
            await this.initialize();
        },
        methods: {
            /**
             * tab id生成器函数
             * @author  韦胜健
             * @date    2019/12/9 12:11
             */
            idGenerator({id, title, path, param, security, data}) {
                let tabId = title + path;
                if (param) {
                    tabId += JSON.stringify(param);
                }
                return 'id<' + tabId + '>';
            },
            /**
             * 初始化页面导航组件
             * @author  韦胜健
             * @date    2019/12/9 12:05
             */
            async initNavigator() {
                this.navigationStorageKey = window.appCtx.appName + window.linkToken.getUsername()
                this.isInitialized = true
                await this.$lv.nextTick()
            },
            /**
             * 初始化页面信息
             * @author  韦胜健
             * @date    2019/12/9 12:00
             */
            async initialize() {
                let path = window.location.href;
                const uselessIndex = path.indexOf('#/');
                if (uselessIndex !== -1) path = path.slice(0, uselessIndex);
                const {param} = this.$lv.$utils.decodeUrl(path);
                if (!param.id && Boolean(param.path)) {
                    await this.openByPage(param);
                } else {
                    await this.openById(param);
                }
            },
            /**
             * 根据id打开页面，适用于从别的系统打开的场景，比如从crm或者dms打开的页面
             * 从localStorage中获取appCtx，同理token也是从localStorage传递的
             * @author  韦胜健
             * @date    2019/6/5 12:01
             */
            async openById(arg) {
                const storage = JSON.parse(window.localStorage.getItem('LinkSingle')) || {};
                const {path, param, security, page404, appCtx, title} = storage[arg.id];
                window.CURRENT_ORIGIN_TOP.appCtx = appCtx;
                document.title = title
                let component;
                try {
                    component = await this.$lv.pageRegistry(path);
                } catch (e) {
                    if (Boolean(page404)) component = await this.$lv.pageRegistry(page404);
                }
                if (Boolean(component)) this.page = {path, param, security};
                await this.initNavigator()
                console.log({...this.page});
                this.$nav.openTab(this.page, true);

            },
            /**
             * 根据path打开页面，适用于根据url直接打开页面的场景，需要在地址栏上加上token以及appName
             * @author  韦胜健
             * @date    2019/6/5 12:01
             */
            async openByPage(arg) {

                /*清除身份标志信息*/
                let un = 'single visitor'
                let expires = '0';
                window.CURRENT_ORIGIN_TOP.appCtx = window.appCtx = {username: un, appName: null};
                ['CRM', 'DMS'].forEach(an => {
                    window.localStorage.setItem(`${an}_Username`, un);
                    window.localStorage.setItem(`${an}_${un}_${linkToken.authKey}`, null);
                    window.localStorage.setItem(`${an}_${un}_Expires`, expires); // 过期事件
                    window.localStorage.setItem(`${an}_${un}_ExpiresTimestamp`, parseInt(expires) + Date.now()); // 过期时间戳
                })

                let {path, token, appName, username, title} = arg;

                if (!!title) {
                    document.title = title
                }

                if (!!token && !!appName && !!username) {
                    /*带token访问特定页面*/
                    if (!(token.startsWith('bearer'))) {
                        token = `bearer ${token}`
                    }

                    appName = appName.toUpperCase();
                    window.CURRENT_ORIGIN_TOP.appCtx = window.appCtx = {username, appName}

                    if (path.indexOf('urlaccess') === -1) {
                        let msg = '只有 [urlaccess] 页面支持通过 url 地址访问！'
                        this.$dialog.show(msg)
                        throw new Error(msg)
                    }

                    const expires = String(1000 * 60 * 30)
                    window.CURRENT_ORIGIN_TOP.appCtx.username = username
                    window.localStorage.setItem(`${appName}_Username`, username);
                    window.localStorage.setItem(`${appName}_${username}_${linkToken.authKey}`, token);
                    window.localStorage.setItem(`${appName}_${username}_Expires`, expires); // 过期时间
                    window.localStorage.setItem(`${appName}_${username}_ExpiresTimestamp`, parseInt(expires) + Date.now()); // 过期时间戳

                    const param = this.$lv.$utils.deepCopy(arg);
                    delete param.path;

                    let component;
                    try {
                        component = await this.$lv.pageRegistry(path);
                        if (Boolean(component)) this.page = {path, param, security: {}, component};
                        await this.initNavigator()
                        this.$nav.openTab(this.page, true);
                    } catch (e) {
                        this.$dialog.show('找不到页面：' + path);
                    }
                } else {
                    /*不带token，访问任意页面*/
                    const param = this.$lv.$utils.deepCopy(arg);
                    delete param.path;

                    let component;
                    try {
                        component = await this.$lv.pageRegistry(path);
                        if (Boolean(component)) this.page = {path, param, security: {}, component};
                        await this.initNavigator()
                        this.$nav.openTab(this.page, true);
                    } catch (e) {
                        console.error(e)
                        this.$dialog.show('找不到页面：' + path);
                    }
                }
            }
        },
    }
</script>

<style lang="scss">
    .link-single-page {
        height: 100%;
        width: 100%;

        .pl-navigator-main {
            padding: 0;

            .pl-navigator-main-page-target {
                padding: 0 !important;
            }
        }
    }
</style>
